import { SettingsPage } from "@risalabs_frontend_org/auth-wrapper";
import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import { DataAccumulatorForSingleOrderProvider } from "../context/dataAccumulatorForSingleOrder";
import AnalyticsNew from "../pages/analyticsNew/analyticsNew";
import ExternalWorklistV2 from "../pages/configurations/pages/externalWorklistV2/externalWorklistV2";
import ExternalEscalations from "../pages/externalEscalations/externalEscalations";
import AuditTrial from "../pages/singleOrderForExternal/components/auditTrial/auditTrial";
import BoNotesForExternal from "../pages/singleOrderForExternal/components/boNotesForExternal/boNotesForExternal";
import DrugTableForExternal from "../pages/singleOrderForExternal/components/drugTableForExternal/drugTableForExternal";
import JCodeDocuments from "../pages/singleOrderForExternal/components/jCodeDocuments/jCodeDocuments";
import SingleOrderForExternalLayout from "../pages/singleOrderForExternal/singleOrderForExternalLayout";
import ViewAllEventsLayout from "../pages/viewAllEventsLayout/viewAllEventsLayout";
import AllPaOrdersForExternal from "../pages/worklists/external/allPaOrdersForExternal/allPaOrdersForExternal";

export const ExternalWorklistRouteConfig = [
  { index: true, element: <ExternalWorklistV2 /> },
  {
    path: "external-worklist",
    element: <ExternalWorklistV2 />,
    children: [
      { index: true, element: <Navigate to="all-pa-orders" replace /> },
      // { path: "final-worklist", element: <FinalWorklist /> },
      { path: "all-pa-orders", element: <AllPaOrdersForExternal /> },

      {
        path: "singleOrderForExternal/:orderId?",
        element: (
          <DataAccumulatorForSingleOrderProvider>
            <SingleOrderForExternalLayout />
          </DataAccumulatorForSingleOrderProvider>
        ),
        children: [
          { index: true, element: <Navigate to="drugs" replace /> },
          { path: "drugs", element: <DrugTableForExternal /> },
          { path: "businessOffice", element: <BoNotesForExternal /> },
          { path: "auditTrial", element: <AuditTrial /> },
          { path: "documents", element: <JCodeDocuments /> },
        ],
      },
      {
        path: "view-all-events/:orderId",
        element: <ViewAllEventsLayout />,
        children: [
          { index: true, element: <Navigate to="drugs" replace /> },
          { path: "drugs", element: <DrugTableForExternal /> },
          { path: "businessOffice", element: <BoNotesForExternal /> },
          { path: "auditTrial", element: <AuditTrial /> },
          { path: "documents", element: <JCodeDocuments /> },
        ],
      },
    ],
  },
  {
    path: "external-analytics",
    element: <AnalyticsNew />,
  },
  {
    path: "external-escalations",
    element: <ExternalEscalations />,
  },
  {
    path: "settings/*",
    element: (
      <SettingsPage
        enabledPages={["profile", "security", "members", "superadmin"]}
        roleOptions={[
          { value: "admin_med_onc", label: "Admin" },
          { value: "standard_med_onc", label: "Member" },
        ]}
      />
    ),
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
];
